/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'arrow-right-grey': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data:
      '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M4.232 2.36a1 1 0 00.128 1.408L9.438 8 4.36 12.232a1 1 0 101.28 1.536l6-5a1 1 0 000-1.536l-6-5a1 1 0 00-1.408.128z" _fill="gray"/>'
  }
})
